import React from 'react';
import { Link } from 'react-router-dom';
import { cn, SECTIONS, fixImageUrl, formatDateSafe } from '../lib/utils';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiMapPin, FiTag } = FiIcons;

const EntryCard = ({ entry }) => {
  const sectionInfo = SECTIONS[entry.section];
  
  // Use excerpt if it exists, otherwise clean up the markdown from body for the preview
  const previewText = entry.excerpt || entry.body?.replace(/[#*`]/g, '').substring(0, 120) + '...';

  return (
    <Link 
      to={`/entry/${entry.id}`} 
      className="group block bg-white rounded-[2rem] overflow-hidden border border-[#e5e0d5] hover:shadow-2xl hover:-translate-y-1 transition-all duration-500"
    >
      <div className="aspect-[16/10] overflow-hidden relative">
        {entry.cover_image_url ? (
          <img 
            src={fixImageUrl(entry.cover_image_url)} 
            alt={entry.title} 
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000" 
            loading="lazy" 
          />
        ) : (
          <div className={cn("w-full h-full flex items-center justify-center bg-stone-50")}>
            <span className="text-6xl opacity-10 font-serif font-bold">{entry.title[0]}</span>
          </div>
        )}
        <div className="absolute top-4 left-4">
          <span className={cn(
            "px-4 py-1.5 rounded-full text-[10px] font-bold uppercase tracking-widest shadow-sm backdrop-blur-md border border-white/20",
            sectionInfo?.color || "bg-white text-stone-800"
          )}>
            {entry.section}
          </span>
        </div>
      </div>

      <div className="p-8">
        <div className="flex items-center text-[10px] font-bold uppercase tracking-widest text-stone-400 mb-4 space-x-4">
          <div className="flex items-center">
            <SafeIcon icon={FiCalendar} className="w-3.5 h-3.5 mr-1.5 text-[#8c7851]" />
            {formatDateSafe(entry.date)}
          </div>
          {entry.location_text && (
            <div className="flex items-center truncate max-w-[150px]">
              <SafeIcon icon={FiMapPin} className="w-3.5 h-3.5 mr-1.5 text-[#8c7851]" />
              <span className="truncate">{entry.location_text}</span>
            </div>
          )}
        </div>

        <h3 className="text-2xl font-serif font-bold mb-3 text-[#2c2c2c] group-hover:text-[#8c7851] transition-colors leading-tight">
          {entry.title}
        </h3>
        
        <p className="text-stone-500 line-clamp-2 leading-relaxed font-medium text-sm italic">
          "{previewText}"
        </p>

        {entry.tags && entry.tags.length > 0 && (
          <div className="mt-6 flex flex-wrap gap-2">
            {entry.tags.slice(0, 3).map(tag => (
              <span key={tag} className="text-[9px] font-bold uppercase tracking-widest bg-stone-50 text-stone-400 px-2.5 py-1 rounded-lg border border-stone-100">
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default EntryCard;